// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31LiK","placeholdersHeader":"styles_placeholdersHeader__3YWpV","editorStyle":"styles_editorStyle__-Z96h","placeholdersBox":"styles_placeholdersBox__E3PgP"};